/**
 * Activity Centre: shows progress/status (e.g. "Generating…", "Opened.", "No document found.")
 * for async actions (e.g. legacy doc Generate/Open/Email, defect popup, etc.).
 * Listeners: Home/compat (home.tsx, dr/Home.tsx). 
 * Callers: Undertaking.tsx.
 */

const LDDActivityCentre = "LDDActivityCentre" as const;

export type ActivityCentreAddType = "load" | "loading" | "success" | "error" | "word";

export interface ActivityCentreAddParam {
    msg: string;
    onclick?: unknown;
    type: ActivityCentreAddType | string;
    lddActivityCenterTracker: number;
    clearWhenOut?: boolean;
    fileNumber?: unknown;
}

/** Add an activity (message) to the Activity Centre. */
export function dispatchActivityCentreAdd(param: ActivityCentreAddParam): void {
    const eventParams = {
        detail: {
            event: "add",
            param: {
                msg: param.msg,
                onclick: param.onclick ?? null,
                type: param.type === "" ? "word" : param.type,
                lddActivityCenterTracker: param.lddActivityCenterTracker,
                clearWhenOut: param.clearWhenOut,
                fileNumber: param.fileNumber,
            },
        },
    };
    // Same pattern as Home/compat.tsx: CustomEvent("LDDActivityCentre", …) + dispatch; we use window.dispatchEvent for explicitness.
    window.dispatchEvent(new CustomEvent(LDDActivityCentre, eventParams));
}

/** Remove an activity by tracker counter. */
export function dispatchActivityCentreDelete(counter: number): void { 
    // Same pattern as Home/compat.tsx (ActivityCentreDel).
    window.dispatchEvent(
        new CustomEvent(LDDActivityCentre, {
            detail: { event: "delete", param: { counter } },
        }),
    );
}
